import React from 'react';
import AnimateHeight from 'react-animate-height';
import { ProductWithBundleId } from '../../../../../../models/CampaignModel';
import { FlowMode } from '../../../../../../models/FlowMode';
import { FCC } from '../../../../../../utils/types';
import { Button } from '../../../../../shared';
import SelectedProducts from './SelectedProducts';
import { ProductTypeConfig } from '~/models/product/ProductTypeConfig';

export const ProductBundleHeader: React.FC<{
  isOpen: boolean;
  config: ProductTypeConfig;
  index: number;
  selectedInBundle: ProductWithBundleId[];
  isVisible: boolean;
  bundleId: string;
  activeBundleId: string;
  flowMode: FlowMode;
  removeBundle: () => void;
  deselectProduct: () => void;
}> = ({ isOpen, config, index, selectedInBundle, isVisible, bundleId, flowMode, activeBundleId, removeBundle, deselectProduct }) => {
  const animateProps = {
    duration: 300,
    animateOpacity: true,
    height: isOpen || !(selectedInBundle.length > 0) ? 0 : 'auto',
  };

  const showRemoveBundleButton = flowMode !== FlowMode.Open && index !== 0 && bundleId === activeBundleId;
  const displayChangeBundleButton = !isOpen && bundleId === activeBundleId;

  const productName = selectedInBundle.map((product) => product.displayData.name);
  const bundleTitle = config?.bundleTitle ? config.bundleTitle.replace('{n}', (index + 1).toString()) : '';
  const removeLabel = `Slett kategori ${bundleTitle}${selectedInBundle.length > 0 ? ` og fjern ${productName} fra handlekurv` : ''}`;
  const displayTitle = isVisible && bundleTitle;

  return (
    <>
      {displayTitle && (
        <div className="product-bundle-title">
          <h3 className="title-3">{bundleTitle}</h3>
          {showRemoveBundleButton && (
            <RemoveBundleButton productName={productName} removeLabel={removeLabel} removeBundle={removeBundle}>
              Angre
            </RemoveBundleButton>
          )}
        </div>
      )}
      <AnimateHeight {...animateProps}>
        <div>
          <SelectedProducts selectedInBundle={selectedInBundle}>
            {displayChangeBundleButton && (
              <Button
                type={'secondary'}
                className="product-bundle-button"
                aria-label={`Endre valg av ${productName}`}
                aria-expanded={isOpen}
                focusOnRender={true}
                onClick={deselectProduct}
                data-track-id="card-button"
                data-track-card-name={productName}
              >
                Endre
              </Button>
            )}
          </SelectedProducts>
        </div>
      </AnimateHeight>
    </>
  );
};

const RemoveBundleButton: FCC<{ removeLabel: string; productName: string[]; removeBundle: () => void }> = ({
  children,
  removeLabel,
  removeBundle,
  productName,
}) => {
  return (
    <Button
      type="link-style"
      onClick={removeBundle}
      aria-label={removeLabel}
      data-track-id="card-button"
      data-track-card-name={productName}
    >
      {children}
    </Button>
  );
};
